import React from "react";
import { Navigate } from "react-router-dom";
import usePermissions from "../hooks/usePermissions";

const ProtectedRoute = ({ children, module, allowedRoles = [] }) => {
  const token = localStorage.getItem("token");

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch {
    user = null;
  }

  const { loading, canView } = usePermissions();
  const userRole = (user?.role || "").toLowerCase().replace(/\s+/g, "_").trim();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-slate-500">
        Loading...
      </div>
    );
  }

  if (userRole === "super_admin") {
    return children;
  }

  if (
    allowedRoles.length > 0 &&
    !allowedRoles.map((role) => role.toLowerCase().replace(/\s+/g, "_").trim()).includes(userRole)
  ) {
    return (
      <div className="h-screen flex items-center justify-center text-red-500 text-lg">
        Access Denied
      </div>
    );
  }

  if (module && !canView(module)) {
    return (
      <div className="h-screen flex items-center justify-center text-red-500 text-lg">
        Access Denied
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
